import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidateItemsComponent } from './validate-items.component';


@NgModule({
  declarations: [ValidateItemsComponent],
  imports: [
    CommonModule
  ],
  exports: [ValidateItemsComponent],
})
export class ValidateItemsModule { }
